import {
  number,
  object,
  type output,
  string,
} from 'zod';

export const MAX_GROUP_DISPLAY_NAME_LENGTH = 100;

export const groupRequestSchema = object({
  programId: number(),
  displayName: string().min(1, 'Enter a display name.').max(MAX_GROUP_DISPLAY_NAME_LENGTH, `Use ${MAX_GROUP_DISPLAY_NAME_LENGTH} characters or fewer for the display name.`),
});

export type GroupRequest = output<typeof groupRequestSchema>;
